
<template>
    <div
        :class="['order-step-1', {'order-step-1--private': mode === 'private'}, `order-step-1--active-option-${subscriptionTypeIndex}`]"
        :style="cssVars"
    >
        <div class="order-step-1__col-container">
            <div
                v-for="(i, index) in items"
                :key="i.id"
                :class="['order-step-1__col', `order-step-1__col-${index + 1}`]"
                @click.prevent="updateActiveSubscriptionType(i.id)"
            >
                <div class="order-step-1__image-container">
                    <img
                        :src="imgSrc(i)"
                        :alt="i.name"
                        class="order-step-1__image"
                    >
                </div>
                <div class="order-step-1__text-container text-container">
                    <h3>{{ i.name }}</h3>
                    <p>{{ i.description }}</p>
                </div>
                <div class="order-step-1__radio-container radio">
                    <label class="order-step-1__label">
                        <input
                            name="subscription-type"
                            type="radio"
                            :value="i.id"
                            :checked="i.id === activeSubscriptionType"
                        >
                        <span class="order-step-1__radio custom-radio"/>
                        <span class="sr-only">{{ i.name }}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({
            subscriptionTypes: state => state.orderable.product_groups,
            activeSubscriptionType: state => state.subscriptionType,
            mode: state => state.mode,
        }),
        subscriptionTypeIndex() {
            return this.items
                .findIndex(s => s.id === this.activeSubscriptionType) + 1;
        },
        items() {
            return this.subscriptionTypes.map((i) => {
                const items = i.products.filter(p => (this.mode === 'private' && p.available_for_private) || (this.mode === 'business' && p.available_for_company));
                if (items.length) {
                    return i;
                }
            }).filter(p => p);
        },
        cssVars() {
            return {
                '--dynamic-width': `${100 / this.items.length}%`
            };
        },
    },
    methods: {
        updateActiveSubscriptionType(id) {
            this.$store.dispatch('resetOrder');
            this.$store.dispatch('updateActiveSubscriptionType', { id });
        },
        imgSrc(item) {
            return this.mode === 'business' ? item.images.office_basket_lg : item.images.private_basket_sm;
        },
    },
};
</script>



// WEBPACK FOOTER //
// SubscriptionTypes.vue?682cfec6